var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"component-attachmentdate"},[_c('v-chip',{attrs:{"x-small":"","outlined":"","color":"info"}},[_vm._v(_vm._s(_vm.dateLong))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }